import { writeFileXLSX, utils } from 'xlsx';

export const exportToExcel = (data, fileName) => {
  const ws = utils.json_to_sheet(data); // Cria uma planilha a partir dos dados
  const wb = utils.book_new(); // Cria um novo livro
  utils.book_append_sheet(wb, ws, 'Relatorio'); // Adiciona a planilha ao livro
  writeFileXLSX(wb, `${fileName}.xlsx`); // Escreve o arquivo XLSX
};
